import { createSelector } from "reselect";
import { RootState } from "../../rootReducer";

export const selectSigners = createSelector(
  [(store: RootState) => store.documentSupervisorShow.signers],
  (data) => data
);
